<template>

    <div class="content-load">

        <Top></Top>
        <!-- Dashboard Container -->
        <div class="dashboard-container">

            <Sidebar></Sidebar>

            <!-- Dashboard Content
            ================================================== -->
            <div class="dashboard-content-container" data-simplebar>
                <div class="dashboard-content-inner" >

                    <div class="uploadButton" style="visibility: hidden; position: absolute;">
                        <input class="uploadButton-input" type="file" name="arquivo" @change="getBase64Arquivo" accept="image/*,.pdf,application/pdf" id="upload-arquivo" />
                        <label class="uploadButton-button ripple-effect" for="upload-arquivo">
                            Anexar arquivo
                        </label>
                    </div>

                    <!-- Dashboard Headline -->
                    <div class="dashboard-headline hidden-xs">
                        <h3>
                            {{$router.currentRoute.meta.title}}

                            <router-link v-if="($root.user.tipo == 'admin' || $root.user.tipo == 'gerencial') && $router.currentRoute.name == 'Vendas'" :to="{'name': 'CadastrarVendas'}" class="button block-mobile big margin-bottom-10  float-right margin-left-10">
                                <i class="material-icons">add</i>
                                Cadastrar
                            </router-link>

                            <router-link v-if="($root.user.tipo == 'admin' || $root.user.tipo == 'prestador' || $root.user.tipo == 'gerencial') && $router.currentRoute.name != 'Vendas'" :to="{'name': 'CadastrarPedidos'}" class="button block-mobile big margin-bottom-10  float-right margin-left-10">
                                <i class="material-icons">add</i>
                                Cadastrar
                            </router-link>

                            <router-link v-if="($root.user.tipo == 'admin'|| $root.user.tipo == 'gerencial') && $router.currentRoute.name != 'Vendas'" :to="{'name': 'CadastrarPedidos', 'query': {'t': 'agendar'}}" class="button block-mobile big margin-bottom-10 float-right  margin-left-10">
                                <i class="material-icons">event_available</i>
                                Agendar
                            </router-link>   

                        </h3>
                        <div class=" hidden-xl" style="height: 40px"></div>   
                        <div class="hidden-lg" style="height: 0px"></div>   
                    </div>

                        
                    <div class="row" v-if="$root.user.tipo == 'contratante'">
                        
                        <div class="col-lg-6 col-xs-12 col-xl-6">
                            <p class="page-text">
                                Confira abaixo todos os seus abastecimentos <b>agendados</b> e os abastecimentos <b>realizados</b>. 
                            </p>
                        </div>

                        <div class="col-xl-8 col-xs-12">
                            <div class="dashboard-box margin-top-0 cards">
                                <div class="content">
                                    <h5 class="block-title hidden-lg hidden-md hidden-xl hidden-sm" v-show="pendentes.itens.length > 0 && pendentes.loaded">
                                        <i class="material-icons">event</i>
                                        Pendentes
                                    </h5>
                                    <div v-if="pendentes.itens.length == 0 && pendentes.loaded && anteriores.itens.length == 0" class="job-overview empty">
                                        <div class="job-overview-inner">
                                            <center>
                                                <i class="material-icons big">mood_bad</i>
                                                <p>Nenhum resultado encontrado.</p>
                                            </center>
                                        </div>      
                                    </div>

                                    <ul class="dashboard-box-list" v-show="pendentes.itens.length > 0 && pendentes.loaded">

                                        <li v-for="item in pendentes.itens" :id="'pedido-item-' + item.cod">
                                            <div class="job-listing card">
                                                <div class="job-listing-details">
                                                    <div class="job-listing-description">
                                                        <div class="row">
                                                            <div class="col-lg-12">
                                                                <h3 class="job-listing-title">
                                                                    <i class="material-icons">access_time</i>
                                                                    <b>
                                                                        {{item.data | formatDate}} às {{item.horaInicio.substr(0,item.horaInicio.length -3)}}h
                                                                    </b>
                                                                </h3>
                                                                <span class="dashboard-status-button" v-bind:class="$root.config.pedidoStatus[item.status].class"><b>{{$root.config.pedidoStatus[item.status].text}}</b></span>
                                                                <span class="dashboard-status-button color-red" v-show="item.erro == 1"><b>{{item.statusObservacao}}</b></span>
                                                            </div>


                                                            <div class="col-lg-12">
                                                                <small>Informações:</small>
                                                                <div class="job-listing-footer">
                                                                    <ul class="margin-top-0">
                                                                        <li>
                                                                            <i class="material-icons">local_gas_station</i> 
                                                                            Produto: <b>{{item.catalogo.nome}}</b>
                                                                        </li>
                                                                        <br> 
                                                                        <li v-if="item.quantidade && item.quantidade != 0">
                                                                            <i class="material-icons">radio_button_unchecked</i> 
                                                                            Quantidade: <b>{{item.quantidade}} </b>
                                                                        </li>
                                                                        <br v-if="item.quantidade && item.quantidade != 0">                                                                         
                                                                        <li>
                                                                            <i class="material-icons">local_airport</i> 
                                                                            Prefixo aeronave: <b>{{item.auxiliar1}}</b>
                                                                        </li>
                                                                        <br> 
                                                                        <li>
                                                                            <i class="material-icons">store</i> 
                                                                            Filial: <b>{{item.empresa.nome}}</b>
                                                                        </li>
                                                                        <br>
                                                                        <li>
                                                                            <i class="material-icons">access_time</i> 
                                                                            Criado em: <b>{{item.datahora | formatDate}}</b>
                                                                        </li>
                                                                        <br>
                                                                        <li v-if="item.status == 2">
                                                                            <i class="material-icons">access_time</i> 
                                                                            Realizado em: <b>{{item.finalizado | formatDate}}</b>
                                                                        </li>                                                                        
                                                                        <br v-if="item.status == 2">
                                                                        <li style="color: #333" v-if="item.total != 0">
                                                                            <i class="material-icons">attach_money</i> 
                                                                            Valor total: <b >R$ {{item.total | toMoney}}</b>
                                                                        </li>                                                                        
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                            <div class="col-lg-12 margin-top-5">
                                                                <small>Ações:</small>
                                                                <br>
                                                           
                                                                <a class="button small gray margin-right-5" v-if="item.status == 1" v-on:click="atrasar(item.cod, '1')">
                                                                    <i class="material-icons">add</i>
                                                                    <b>1h</b> atraso
                                                                </a>               
                                                                <a class="button small gray margin-right-5" v-if="item.status == 1" v-on:click="atrasar(item.cod, '2')">
                                                                    <i class="material-icons">add</i>
                                                                    <b>2h</b> atraso
                                                                </a>                                                                                                                                
                                                                <a class="button small red margin-right-5" v-if="item.status >= 0 && item.status < 2" v-on:click="cancelar(item.cod)">
                                                                    <i class="material-icons">close</i>
                                                                    Cancelar
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>                                        

                                    </ul>
                                        

                                    <h5 class="block-title hidden-lg hidden-md hidden-xl hidden-sm" v-show="anteriores.itens.length > 0 && loaded">
                                        <i class="material-icons">keyboard_backspace</i>
                                        Anteriores
                                    </h5>

                                    <ul class="dashboard-box-list" v-show="anteriores.itens.length > 0 && loaded">
                                         
                                        <li v-for="item in anteriores.itens">
                                            <div class="job-listing card">
                                                <div class="job-listing-details">
                                                    <div class="job-listing-description">
                                                        <div class="row">
                                                            <div class="col-lg-12">
                                                                <h3 class="job-listing-title">
                                                                    <i class="material-icons">access_time</i>
                                                                    <b>
                                                                        {{item.data | formatDate}} às {{item.horaInicio.substr(0,item.horaInicio.length -3)}}h
                                                                    </b>
                                                                </h3>
                                                                <span class="dashboard-status-button" v-bind:class="$root.config.pedidoStatus[item.status].class"><b>{{$root.config.pedidoStatus[item.status].text}}</b></span>
                                                            </div>


                                                            <div class="col-lg-12">
                                                                <small>Informações:</small>
                                                                <div class="job-listing-footer">
                                                                    <ul class="margin-top-0">
                                                                        <li>
                                                                            <i class="material-icons">local_gas_station</i> 
                                                                            Produto: <b>{{item.catalogo.nome}}</b>
                                                                        </li>
                                                                        <br> 
                                                                        <li v-if="item.quantidade">
                                                                            <i class="material-icons">radio_button_unchecked</i> 
                                                                            Quantidade: <b>{{item.quantidade}} </b>
                                                                        </li>
                                                                        <br v-if="item.quantidade">                                                                         
                                                                        <li>
                                                                            <i class="material-icons">local_airport</i> 
                                                                            Prefixo aeronave: <b>{{item.auxiliar1}}</b>
                                                                        </li>
                                                                        <br> 
                                                                        <li>
                                                                            <i class="material-icons">store</i> 
                                                                            Filial: <b>{{item.empresa.nome}}</b>
                                                                        </li>
                                                                        <br>
                                                                        <li>
                                                                            <i class="material-icons">access_time</i> 
                                                                            Criado em: <b>{{item.datahora | formatDate}}</b>
                                                                        </li>
                                                                        <br>
                                                                        <li v-if="item.status == 2">
                                                                            <i class="material-icons">access_time</i> 
                                                                            Realizado em: <b>{{item.finalizado | formatDate}}</b>
                                                                        </li>                                                                        
                                                                        <br v-if="item.status == 2">
                                                                        <li v-if="item.status == -1">
                                                                            <i class="material-icons">close</i> 
                                                                            Motivo de cancelamento: <b>{{item.statusObservacao}}</b>
                                                                        </li>                       

                                                                        <li v-if="item.nfNumero" style="display: block; margin-top: 4px;">
                                                                            <i class="material-icons">description</i>
                                                                            Nº da NF: <b>{{item.nfNumero}}</b>
                                                                        </li>    

                                                                        <li v-if="item.boletoNumero" style="display: block; margin-top: 4px;">
                                                                            <i class="material-icons">description</i>
                                                                            Nº do boleto: <b>{{item.boletoNumero}}</b>
                                                                        </li>                                                                           

                                                                        <li v-if="item.numero" style="display: block; margin-top: 4px;">
                                                                            <i class="material-icons">receipt</i>
                                                                            Nº ordem: <b>{{item.numero}}</b>
                                                                        </li>                       

                                                                        <li style="display: block; ">
                                                                            <span v-if="item.ativo == 1" class="dashboard-status-button sm margin-top-5" v-bind:class="{'green': item.pago == 1, 'color-orange': item.pago == 0 && !item.nfNumero, 'color-blue': item.pago == 0 && item.nfNumero}">
                                                                                {{item.pago == 1 ? "Ordem paga" : (item.nfNumero ? "Ordem processada" : "Ordem pendente")}}

                                                                            </span>

                                                                            <div class="hidden-xs hidden-md" style="height: 5px;"></div>

                                                                            <span style="margin-left: 2px;" class="dashboard-status-button gray sm" v-if="item.formaPagamento == 'pix'">
                                                                                PIX
                                                                            </span>
                                                                            <span style="margin-left: 2px;" class="dashboard-status-button gray sm" v-if="item.formaPagamento == 'deposito'">
                                                                                Depósito
                                                                            </span>
                                                                            <span style="margin-left: 2px;" class="dashboard-status-button gray sm" v-if="item.formaPagamento == 'transferencia'">
                                                                                Transferência
                                                                            </span>      

                                                                        </li>                                                                                                                                   

                                                                        <li style="color: #333; width: 100%;" v-if="item.total != 0">
                                                                            <i class="material-icons">attach_money</i> 
                                                                            Valor total: <b >R$ {{item.total | toMoney}}</b>

                                                                            <a v-if="item.comprovante" v-on:click="verComprovante($root.config.url + '/' + item.comprovante)" style="float: right;">
                                                                                <i class="material-icons" style="margin-right: 0px">attach_file</i>
                                                                                Ver comprovante
                                                                            </a>

                                                                        </li>          

                                                                        <li style="color: #333; width: 100%;" v-if="item.total != 0 && item.doc">
                                                                            <a v-on:click="verComprovante($root.config.url + '/' + item.doc)" class="button gray small block-mobile margin-top-10">
                                                                                <i class="material-icons" style="margin-right: 0px">receipt</i>
                                                                                Ver ordem
                                                                            </a>

                                                                        </li>                                                                                                                                                
                                                                    </ul>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>                                                                             

                                    </ul>                                    
                                </div>
                            </div>
                        </div>
                    </div>

                        
                    <div class="row" v-if="$root.user.tipo == 'admin' || $root.user.tipo == 'prestador' || $root.user.tipo == 'gerencial'">

                        <!-- Dashboard Box -->
                        <div class="col-lg-12 margin-bottom-10 hidden-xl hidden-lg hidden-md" v-if="$router.currentRoute.name == 'Vendas'">
                            <div class="row">
                                <div class="col-xs-12">
                                    <router-link :to="{'name': 'CadastrarVendas'}" class="button block-mobile big margin-bottom-10">
                                        <i class="material-icons">add</i>
                                        Cadastrar
                                    </router-link>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-12 margin-bottom-10 hidden-xl hidden-lg hidden-md" v-if="$router.currentRoute.name != 'Vendas'">
                            <div class="row">
                                <div class="col-xs-6">
                                    <router-link :to="{'name': 'CadastrarPedidos'}" class="button block-mobile big margin-bottom-10">
                                        <i class="material-icons">add</i>
                                        Cadastrar
                                    </router-link>
                                </div>
                                <div class="col-xs-6">
                                    <router-link v-if="$root.user.tipo == 'admin' || $root.user.tipo == 'gerencial'" :to="{'name': 'CadastrarPedidos', 'query': {'t': 'agendar'}}" class="button block-mobile big margin-bottom-10">
                                        <i class="material-icons">event_available</i>
                                        Agendar
                                    </router-link>                            
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-12">                        

                            <form method="get" style="width: 100%;" class="margin-bottom-0" v-on:submit.prevent="form.page = 1;get(true);" novalidate="">
                                <div class="row">
                                    <div class="col-lg-6 col-xs-12 col-xl-6">
                                        <div class="submit-field margin-bottom-10">
                                            <h5>Pesquisar:</h5>
                                            <input type="text" class="with-border margin-bottom-0" placeholder="Pesquise algum abastecimento aqui.." v-if="$router.currentRoute.name != 'Vendas'" name="pesquisa" v-model="form.pesquisa">
                                            <input type="text" class="with-border margin-bottom-0" placeholder="Pesquise alguma venda aqui.." v-if="$router.currentRoute.name == 'Vendas'" name="pesquisa" v-model="form.pesquisa">
                                        </div>
                                    </div>
                                    <!-- <div class="col-xl-12 clearfix"></div> -->
                                    <div class="col-lg-4 col-xs-6 col-xl-3 col-md-5">
                                        <div class="submit-field margin-bottom-10">
                                            <h5>De:</h5>
                                            <input type="date" data-placeholder="___ /____ /_____" required="" class="with-border margin-bottom-0" v-model="form.dataInicio">
                                        </div>
                                    </div>        
                                    <div class="col-lg-4 col-xs-6 col-xl-3 col-md-5">
                                        <div class="submit-field margin-bottom-10">
                                            <h5>Até:</h5>
                                            <input type="date" data-placeholder="___ /____ /_____" required="" class="with-border margin-bottom-0" v-model="form.dataFinal">
                                        </div>
                                    </div>                                                                
                                    <div class="col-lg-4 col-xs-9 col-xl-4 col-md-6" v-if="$root.user.tipo == 'admin' || $root.user.tipo == 'gerencial'">
                                        <div class="submit-field margin-bottom-10">
                                            <h5>Filial:</h5>
                                            <select class="with-border margin-bottom-0" v-model="form.empresaCod" name="empresaCod">
                                                <option value="" selected>Todas</option>
                                                <option v-for="item in empresas.itens" :value="item.cod">{{item.nome}}</option>
                                            </select> 
                                        </div>
                                    </div>                                                                

                                    <div class="col-lg-1 col-xs-2">
                                        <div class="submit-field" >
                                            <div class="hidden-xl  hidden-md hidden-sm clearfix" v-if="$root.user.tipo == 'admin'" style="margin-top: 27px;"></div>
                                            <div class="hidden-xs  hidden-lg clearfix" style="margin-top: 32px;"></div>
                                            <button class="button gray ">
                                                <i class="material-icons">search</i>
                                            </button>                                          
                                            <!-- <div class="hidden-xs hidden-xl hidden-md clearfix" style="margin-top: 10px;"></div> -->
                                        </div>
                                    </div>
                                </div>
                                <div class="hidden-sm hidden-xl margin-top-20"></div>
                            </form> 

                            <div class="table-scroll" style="overflow-x: scroll;">

                                <table class="table table-bordered table-bordered-default table-responsive">
                                    <thead>
                                        <th style="min-width: 80px; width: 80px;">
                                            Nº ordem
                                        </th>
                                        <th style="min-width: 200px;">
                                            Detalhes
                                        </th>
<!--                                         <th style="min-width: 110px; width: 110px;">
                                            Pref. aeronave
                                        </th>   -->      
                                        <th style="min-width: 120px; width: 120px;">
                                            Produto
                                        </th>                                                 
                                        <th style="min-width: 130px; width: 130px;" v-if="$root.user.tipo == 'admin' || $root.user.tipo == 'gerencial'">
                                            Filial
                                        </th>                                                                                                   
<!--                                         <th style="min-width: 155px; width: 155px;">
                                            Agendamento
                                        </th> -->
                                        <th style="min-width: 130px; width: 130px;">
                                            Realizado em
                                        </th>
                                        <th style="min-width: 120px; width: 120px;">
                                            Valor
                                        </th>   
                                        <th style="min-width: 110px; width: 110px;">
                                            Ações
                                        </th>                                                                        
                                    </thead>
                                    <tbody> 

                                        <tr v-show="data.itens.length == 0 && data.loaded">
                                            <td colspan="9">
                                                Nenhum resultado encontrado.
                                            </td>
                                        </tr>

                                        <tr v-for="item in data.itens">
                                            <td data-label="Nº ordem">
                                                <b style="font-size: 18px;">{{item.numero}}</b>
                                                <br>
                                                <small style="color: #777;">
                                                    <b>ID:</b> {{item.id}}
                                                </small>
                                            </td>
                                            <td data-label="Detalhes">
                                                <u>{{item.cliente.razaoSocial ? item.cliente.razaoSocial : item.cliente.nome}}</u>
                                                
                                                <br v-if="item.contratante && $router.currentRoute.name != 'Vendas'">
                                                <small v-if="item.contratante && $router.currentRoute.name != 'Vendas'"><i class="material-icons">people</i> Piloto:    <strong style="font-weight: bold !important; color: #000;">{{item.contratante.nome}}</strong></small>
                                                
                                                <br v-if="$router.currentRoute.name != 'Vendas'">                                                
                                                <small v-if="$router.currentRoute.name != 'Vendas'"><i class="material-icons">airplanemode_active</i> Pref. aeronave:    <strong style="font-weight: bold !important; color: #000;">{{item.auxiliar1}}</strong></small>
                                                <!-- <br v-if="$router.currentRoute.name != 'Vendas'"> -->

                                                <small v-if="item.ativo == -1">
                                                    <br>
                                                    <i class="material-icons">close</i> Motivo cancelamento:    
                                                    <strong style="font-weight: bold !important; color: #000;">{{item.statusObservacao}}</strong>
                                                </small>

                                                <span class="dashboard-status-button green float-right" style="margin: 2px" v-if="item.conferidoAdmin == 1">
                                                    <i class="material-icons" style="color: #fff;">check</i>A
                                                </span>
                                                <span class="dashboard-status-button green float-right" style="margin: 2px" v-if="item.conferidoGerencial == 1">
                                                    <i class="material-icons" style="color: #fff;">check</i>G
                                                </span>                                                

                                            </td>
                                            <td data-label="Produto">
                                                {{item.catalogo.nome}}<br>
                                                <small v-show="item.quantidade && item.quantidade != 0"><i class="material-icons">local_gas_station</i>{{item.quantidade && item.quantidade != 0 ? item.quantidade : ''}} {{item.catalogo.estoque == '1' ? "litro(s)" : "unidade(s)"}}</small>
                                            </td> 
                                            <td data-label="Filial" v-if="$root.user.tipo == 'admin' || $root.user.tipo == 'gerencial'">
                                                {{item.empresa.nome}}
                                            </td>    
                                            <td data-label="Realizado em">
                                                {{item.finalizado | formatDate}}
                                            </td>                                            
                                            <td data-label="Valor">
                                                R$ {{item.valor | toMoney}}
                                                <span v-if="item.ativo == 1" class="dashboard-status-button margin-top-5" v-bind:class="{'green': item.pago == 1, 'color-orange': item.pago == 0 && !item.nfNumero, 'color-blue': item.pago == 0 && item.nfNumero}">
                                                    {{item.pago == 1 ? "Pago" : (item.nfNumero ? "Processada" : "Pendente")}}

                                                </span>
                                                <span v-if="item.ativo == -1" class="dashboard-status-button margin-top-5 color-red">
                                                    Cancelada
                                                </span>

                                                <div class="hidden-xs hidden-md" style="height: 5px;"></div>

                                                <span style="margin-left: 2px;" class="dashboard-status-button gray" v-if="item.formaPagamento == 'pix'">
                                                    PIX
                                                </span>
                                                <span style="margin-left: 2px;" class="dashboard-status-button gray" v-if="item.formaPagamento == 'deposito'">
                                                    Depósito
                                                </span>
                                                <span style="margin-left: 2px;" class="dashboard-status-button gray" v-if="item.formaPagamento == 'transferencia'">
                                                    Transferência
                                                </span>                                                                                                

                                                <a v-if="item.comprovante" v-on:click="verComprovante($root.config.url + '/' + item.comprovante)" style="">
                                                    <i class="material-icons" style="margin-right: 0px; font-size: 18px !important; margin-right: 0px !important; top: 3px !important">attach_file</i>✅
                                                </a>

                                                <div v-if="item.nfNumero" style="height: 5px;"></div>
                                                <small v-if="item.nfNumero">NF:    <strong style="font-weight: bold !important; color: #000;">{{item.nfNumero}}</strong></small>                                                

                                                <div v-if="item.boletoNumero" style="height: 5px;"></div>
                                                <small v-if="item.boletoNumero">Nº Boleto:    <strong style="font-weight: bold !important; color: #000;">{{item.boletoNumero}}</strong></small>                                                

                                            </td>
                                            <td data-label="">

                                                <nav id="navigation" v-if="item.ativo == 1">
                                                    <ul id="responsive" style="display: block !important">
                                                        <li>
                                                            <a class="button small gray">
                                                                Ações
                                                                <i class="material-icons">launch</i>
                                                            </a>
                                                            <ul class="dropdown-nav">
                                                                <li v-show="item.pago != 1">
                                                                    <a v-on:click="pago(item.cod, item.pago)">
                                                                        <i class="material-icons">check_circle</i>
                                                                        Definir como pago
                                                                    </a>
                                                                </li>
                                                                <li v-show="item.pago == 1">
                                                                    <a v-on:click="pago(item.cod, item.pago)">
                                                                        <i class="material-icons">warning</i>
                                                                        Pagamento pendente
                                                                    </a>
                                                                </li>                                                                
                                                                <li>
                                                                    <a v-if="!item.comprovante" v-on:click="addComprovante(item.cod)">
                                                                        <i class="material-icons">attach_file</i>
                                                                        Anexar comprovante
                                                                    </a>
                                                                    <a v-if="item.comprovante" v-on:click="verComprovante($root.config.url + '/' + item.comprovante)">
                                                                        <i class="material-icons">attach_file</i>
                                                                        Ver comprovante
                                                                    </a>                                                                    
                                                                </li>
                                                                <li>
                                                                    <a v-bind:class="{'disabled': !item.doc}" :href="$root.config.url + '/' + item.doc" target="_blank">
                                                                        <i class="material-icons">receipt</i>
                                                                        Ver ordem
                                                                    </a>
                                                                </li>
                                                                <li>
                                                                    <a v-on:click="addNfNumero(item.cod)">
                                                                        <i class="material-icons">description</i>
                                                                        Add Nº NF
                                                                    </a>
                                                                </li>
                                                                <li v-if="item.formaPagamento == 'boleto' || !item.formaPagamento">
                                                                    <a v-on:click="addBoletoNumero(item.cod)">
                                                                        <i class="material-icons">insert_drive_file</i>
                                                                        Add Nº boleto
                                                                    </a>
                                                                </li>                                                                
                                                                <li v-if="!item.observacoes">
                                                                    <a v-on:click="addObservacoes(item.cod)">
                                                                        <i class="material-icons">message</i>
                                                                        Add observações
                                                                    </a>
                                                                </li>
                                                                <li v-if="item.observacoes">
                                                                    <a v-on:click="verObservacoes(item)">
                                                                        <i class="material-icons">message</i>
                                                                        Ver observações
                                                                    </a>
                                                                </li>                                              
                                                                <li v-if="$root.user.tipo == 'admin' && item.conferidoAdmin == 0">
                                                                    <a v-on:click="conferido(item.cod)">
                                                                        <i class="material-icons">check_box</i>
                                                                        Conferido
                                                                    </a>
                                                                </li>
                                                                <li v-if="$root.user.tipo == 'gerencial' && item.conferidoGerencial == 0">
                                                                    <a v-on:click="conferido(item.cod)">
                                                                        <i class="material-icons">check_box</i>
                                                                        Conferido
                                                                    </a>
                                                                </li>                                                                
                                                                <li>
                                                                    <router-link :to="{'name': 'EditarPedidos', 'query': {'c': item.cod}}" v-if="item.tipo != 'venda'">
                                                                        <i class="material-icons">edit</i>
                                                                        Editar
                                                                    </router-link>
                                                                </li>
                                                                <li>
                                                                    <a v-on:click="del(item.cod)" v-if="$root.user.tipo == 'admin'">
                                                                        <i class="material-icons">delete</i>
                                                                        Apagar
                                                                    </a>
                                                                </li>
                                                            </ul>
                                                        </li>
                                                    </ul>
                                                </nav>

                                            </td>
                                        </tr>

                                    </tbody>
                                </table>

                                <div class="pagination-container margin-top-60 margin-bottom-60">
                                    <nav class="pagination">
                                        <ul>
                                            <li class="pagination-arrow" v-show="data.page > 1" v-on:click="form.page = (data.page - 1); get(true);">
                                                <a>
                                                    <i class="material-icons">arrow_back</i>
                                                    Anterior
                                                </a>
                                            </li>
                                            <li class="pagination-arrow" v-show="data.page >= 1 && data.page < (data.pages.length)" v-on:click="form.page = (data.page + 1); get(true);">
                                                <a>
                                                    Próxima
                                                    <i class="material-icons">arrow_forward</i>
                                                </a>
                                            </li>    
                                            <br class="hidden-lg hidden-xl hidden-md">                                        
                                            <li v-for="(item, index) in data.pages" v-show="item.show">
                                                <a class="" v-bind:class="{'current-page': item.index == data.page}" v-on:click="form.page = item.index; get(true);">
                                                    {{item.index}}
                                                </a>
                                            </li>
                                        </ul>
                                    </nav>
                                </div>


                            </div>
                        </div>

                    </div>                    

                </div>
            </div>
        </div>
        <Toolbar></Toolbar>

    </div>
</template>

<script>
import Top from './Top'
import Toolbar from './Toolbar'
import Sidebar from './Sidebar'

export default {
    name:                           'Catalogo',
    components: {
        'Top':                      Top,
        'Sidebar':                  Sidebar,
        'Toolbar':                  Toolbar
    },     
    filters: {
        toMoney: function(value) {
            if (value) {
                return parseFloat(value).toLocaleString('pt-br', {minimumFractionDigits: 2})                
            } else {
                return "0,00";
            }
            // return value.toLocaleString('pt-br', {minimumFractionDigits: 2})                
        },        
        formatDate: function(value) {
            if (!value) {
                return "";
                return false;
            }
            var d = value.split(" ");
            var date = d[0];
            var time = d[1];
            d = date.split("-");
            date = d[2] + "/" + d[1] + "/" + d[0];
            if (time) {
                d = time.split(":");
                time = d[0] + ":" + d[1];
            }
            // return formatDate(value.replace(" ", "T")) + " " + formatHours(value.replace(" ", "T"));
            return date + (time ? (" " + time) : "");
        }
    },        
    data () {
        var self                    = this;
        return {
            "loaded":               false,
            "empresas":             {
                "itens":            []
            },
            "pendentes":        {
                "itens":        []
            },
            "anteriores":       {
                "itens":        []
            },
            "data":                 {
                "itens":            []
            },
            "loading": {
                "submit":           false
            },
            "form": {
                "_cod":             self.$root.user.cod,
                "_token":           self.$root.user.token,
                "tipo":             "agendamento",
                "empresaCod":       "",
                "dataInicio":       "",
                "dataFinal":        "",
            },
            "formComprovante":  {
                "_cod":         self.$root.user.cod, 
                "_token":       self.$root.user.token,
                "pedidoCod":    null,
                "acao":         "comprovante",
                "comprovante":  null,
            }            
        }
    },
    methods: {
        conferido: function(cod) {
            console.log("conferido()", cod);
            var self                = this;
            confirm("Você tem certeza que deseja definir como conferido?", function() {

                var form = {
                    "_cod":         self.$root.user.cod, 
                    "_token":       self.$root.user.token,
                    "pedidoCod":    cod,
                    "acao":         "conferido"
                }; 
                loading.show();
                
                axios.put("api/pedidos.php", form)
                .then(response => {
                    console.log("conferido() response", response)
                    alert(response.data.message);
                    self.get(true);
                })
                .catch(error => {
                    console.log("conferido() error", error)
                    loading.hide();
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });
            });
        },        
        verObservacoes: function(item) {
            var self = this;
            console.log("verObservacoes()", item);

            item.observacoes    = item.observacoes.replaceAll("\n", '\n');

            if (!window.cordova) {
                alert("Observações do abastecimento " + item.numero + ":\n\n" + item.observacoes);
            } else {
                navigator.notification.alert(item.observacoes, function(){}, "Observações do abastecimento " + item.numero, "Ok")
            }
        },
        addObservacoes: function(cod) {
            console.log("addObservacoes()", cod);
            var self                = this;

            var texto               = prompt("Escreva as observações:");
            if (!texto)             return false; 

            var form = {
                "_cod":         self.$root.user.cod, 
                "_token":       self.$root.user.token,
                "pedidoCod":    cod,
                "acao":         "observacoes",
                "observacoes":  texto
            };                

            loading.show();
            
            axios.put("api/pedidos.php", form)
            .then(response => {
                console.log("addObservacoes() response", response)
                
                self.get(true);
                alert(response.data.message);
            })
            .catch(error => {
                console.log("addObservacoes() error", error)
                loading.hide();
                
                alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
            });

        },          
        verComprovante: function(link) {
            var self = this;

            window.open(link, "_system");
        },
        addComprovante: function(cod) {
            console.log("addComprovante()", cod);
            var self                = this;

            self.formComprovante.pedidoCod    = cod;

            $(".uploadButton-button[for='upload-arquivo']").click();        
        },        
        getBase64Arquivo: function(event) {
            console.log(">", event.target.files)
            var self            = this;

            var request         = function() {
                console.log("request()");

                loading.show();
                
                axios.put("api/pedidos.php", self.formComprovante)
                .then(response => {
                    console.log("addComprovante() response", response)
                    
                    self.get(true);
                    alert(response.data.message);
                    // limpa formcomprovante
                })
                .catch(error => {
                    console.log("addComprovante() error", error)
                    loading.hide();
                    
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });
            
            };

            if (event.target.files[0]) {
                
                // var form            = {
                //     "_cod":         self.$root.user.cod, 
                //     "_token":       self.$root.user.token,
                //     "pedidoCod":    cod,
                //     "acao":         "pago",
                //     "pago":         (parseFloat(status) == 1 ? 0 : 1)
                // };                
                

                loading.show();
                reduceFileSize(event.target.files[0], 500*1024, 1000, Infinity, 0.9, blob => {
                    blobToBase64(blob, function(result) {
                        // console.log("result", result);
                        loading.hide();
                        self.formComprovante.comprovante    = result;
                        request();
                    });
                }); 
            }   
        },           
        pago: function(cod, status) {
            console.log("pago()", cod);
            var self                = this;
            var form            = {
                "_cod":         self.$root.user.cod, 
                "_token":       self.$root.user.token,
                "pedidoCod":    cod,
                "acao":         "pago",
                "pago":         (parseFloat(status) == 1 ? 0 : 1)
            };                
            
            var definirPago = function() {
                confirm("Você tem certeza que deseja alterar o status do pagamento para " + (status == 1 ? "pendente" : "pago") + "?", function() {

                    console.log("pago:", form);

                    loading.show();
                    
                    axios.put("api/pedidos.php", form)
                    .then(response => {
                        console.log("pago() response", response)
                            
                        // loading.hide();
                        // alert(response.data.message);
                        self.get(true);
                    })
                    .catch(error => {
                        console.log("pago() error", error)
                        loading.hide();
                        alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                        
                    });
                });
            }

            if (status == 1) {
                definirPago();
                return false;
            }

            window.__app.$iosAlertView({
                "title": "Qual a forma de pagamento?", 
                "buttons": [
                    {
                        text: 'PIX',
                        bold: true,
                        onClick: function(data){
                            form.formaPagamento = 'pix';
                            definirPago();
                            // alert("Em desenvolvimento")
                            // definirPago();
                        }
                    },
                    {
                        text: 'Depósito',
                        bold: true,
                        onClick: function(data){
                            form.formaPagamento = 'deposito';
                            definirPago();
                            // alert("Em desenvolvimento")
                            // definirPago();
                        }
                    },
                    {
                        text: 'Transferência',
                        bold: true,
                        onClick: function(data){
                            form.formaPagamento = 'transferencia';
                            definirPago();
                            // alert("Em desenvolvimento")
                            // definirPago();
                        }
                    },   
                    {
                        text: 'Boleto',
                        bold: true,
                        onClick: function(data){
                            form.formaPagamento = 'boleto';
                            definirPago();
                            // alert("Em desenvolvimento")
                            // definirPago();
                        }
                    },                       
                    {
                        text: 'Voltar',
                        bold: false,
                        onClick: function(data){
                          // data.index
                          // data.button
                          // data.value
                        }
                    },           
                ]
            });


        },        
        del: function(cod) {
            console.log("del()", cod);
            var self                = this;
            confirm("Você tem certeza que deseja apagar esse item?", function() {
                var form                = JSON.parse(JSON.stringify(self.form));
                form.cod                = cod;

                var texto               = prompt("Qual o motivo do cancelamento?");
                if (!texto)             return false; 
                form.statusObservacao   = texto;

                self.loading.del        = true;
                loading.show();
                
                axios.delete("api/pedidos.php", {params: form})
                .then(response => {
                    console.log("del() response", response)
                    alert(response.data.message);
                    self.loading.del    = false;
                    self.get(true);
                })
                .catch(error => {
                    console.log("del() error", error)
                    loading.hide();
                    self.loading.del    = false;
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });
            });
        },
        get: function(e) {
            var self        = this;
            console.log("get()", self.form);
            if (e) loading.show();
            return new Promise(function(resolve, reject) {

                if (self.$root.user.tipo == "admin" || self.$root.user.tipo == "prestador" || self.$root.user.tipo == "gerencial") {
                    self.form.filtro            = "finalizados";
                }

                axios.get("api/pedidos.php", {params: self.form, db: "pedidos"})
                .then(response => {
                    
                    console.log("get() response", response);

                    if (self.$root.user.tipo == "contratante") {
                        self.pendentes.itens   = [];
                        self.anteriores.itens  = [];
                        response.data.result.itens.forEach(function(item) {
                            if (item.status >= 0 && item.status <= 1) {
                                self.pendentes.itens.push(item);
                            } else {
                                self.anteriores.itens.push(item);
                            }
                        });
                        self.pendentes.loaded   = true;
                        self.anteriores.loaded  = true;
                    } else {
                        self.data               = response.data.result; 
                    }

                    self.loaded                 = true;
                    if (e) loading.hide();
                    self.$forceUpdate();
                    if (self.$root.user.tipo != "contratante") self.$root.scrollTop();
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("get() error", error);                    
                    if (e) loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });   
            });   
        }, 
        getEmpresas: function() {
            var self        = this;
            console.log("getEmpresas()");
            
            return new Promise(function(resolve, reject) {

                if (self.$root.user.tipo != "admin" && self.$root.user.tipo != "prestador" && self.$root.user.tipo != "gerencial") {
                    return resolve(true);
                }

                var form = {
                    "db":               "empresas",
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token
                    }
                };

                axios.get("api/empresas.php", form)
                .then(response => {
                    
                    console.log("getEmpresas() response", response);
                    self.empresas       = response.data.result;
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("getEmpresas() error", error);                    
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));                
                });   
            });   
        },          
        cancelar: function(cod) {
            console.log("cancelar()", cod);
            var self                = this;
            confirm("Você tem certeza que deseja cancelar?", function() {
                var texto               = prompt("Qual o motivo do cancelamento?");
                if (!texto)             return false; 
                self.loading.cancelar   = true;
             
                var form = {
                    "_cod":         self.$root.user.cod, 
                    "_token":       self.$root.user.token,
                    "pedidoCod":    cod,
                    "acao":         "cancelar",
                    "texto":        texto
                };                

                loading.show();
                
                axios.put("api/agendamento.php", form)
                .then(response => {
                    console.log("cancelar() response", response)
                    self.loading.cancelar    = false;
                    self.get(true);
                    alert(response.data.message);
                })
                .catch(error => {
                    console.log("cancelar() error", error)
                    loading.hide();
                    self.loading.cancelar    = false;
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });
            });
        },
        atrasar: function(cod, quantidade) {
            console.log("atrasar()", cod);
            var self                = this;
            confirm("Você tem certeza? A filial será notificada sobre o atraso", function() {
                self.loading.atrasar   = true;
                
                var texto;
                if (quantidade == 1) {
                    texto      = "1 hora";
                } else {
                    texto      = "2 horas";
                }

                var form = {
                    "_cod":         self.$root.user.cod, 
                    "_token":       self.$root.user.token,
                    "pedidoCod":    cod,
                    "acao":         "atrasar",
                    "texto":        texto
                };                

                loading.show();
                
                axios.put("api/agendamento.php", form)
                .then(response => {
                    console.log("atrasar() response", response)
                    self.loading.atrasar    = false;
                    self.get(true);
                    alert(response.data.message);
                })
                .catch(error => {
                    console.log("atrasar() error", error)
                    loading.hide();
                    self.loading.cancelar    = false;
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });
            });
        },
        addNfNumero: function(cod) {
            console.log("addNfNumero()", cod);
            var self                = this;
            var  numero             = prompt("Por favor, informe o número da NF");
            if (!numero) return false;

            var form = {
                "_cod":         self.$root.user.cod, 
                "_token":       self.$root.user.token,
                "pedidoCod":    cod,
                "acao":         "nfNumero",
                "nfNumero":     numero
            };                

            loading.show();
            
            axios.put("api/pedidos.php", form)
            .then(response => {
                console.log("addNfNumero() response", response)
                
                self.get(true);
                alert(response.data.message);
            })
            .catch(error => {
                console.log("addNfNumero() error", error)
                loading.hide();
                
                alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
            });
        
        },
        addBoletoNumero: function(cod) {
            console.log("addBoletoNumero()", cod);
            var self                = this;
            var  numero             = prompt("Por favor, informe o número do boleto");
            if (!numero) return false;

            var form = {
                "_cod":         self.$root.user.cod, 
                "_token":       self.$root.user.token,
                "pedidoCod":    cod,
                "acao":         "boletoNumero",
                "boletoNumero": numero
            };                

            loading.show();
            
            axios.put("api/pedidos.php", form)
            .then(response => {
                console.log("addBoletoNumero() response", response)
                
                self.get(true);
                alert(response.data.message);
            })
            .catch(error => {
                console.log("addBoletoNumero() error", error)
                loading.hide();
                
                alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
            });
        
        },        
        init: function() {
            var self = this;
            self.get().then(function() {
                return self.getEmpresas();
            }).then(function() {
                if (self.$route.query.c) {
                    $(".dashboard-content-inner")[0].scrollTo({
                        top:            $("#pedido-item-" + self.$route.query.c)[0].getBoundingClientRect().top - 75,
                        behavior:       "smooth"
                    });
                }                  
                console.log("Buscou empresas")
                loading.hide();
            }).catch(function(error) {
                console.log("erro ao buscar", error);
                loading.hide();
            });            
        }                   
    },
    created: function() {
        var self = this;

        if (self.$router.currentRoute.name == "Vendas") {
            self.form.tipo  = "venda";
        }

        loading.show();
        if (!self.$root.db) {
            self.$root.$on("initDB", function(data) {
                self.init();
            });
        } else {
            self.init();
        }      
    },
    mounted: function() {
    }    
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .card .dashboard-status-button {
        margin-top: 8px;
    }

    .sm {
        font-size: 12px; 
        padding: 2px 8px; 
        line-height: 14px; 
        margin-top: 4px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Pedidos.vue